import { useEffect, useMemo, useState } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import {db as firestore } from "../../../../backend/firebaseConfig";
import { useUserEmail } from "../../../../context/UserEmailContext";

export const CHECK_TYPES = {
  ENHANCED: "enhanced",
  STANDARD: "standard",
  SIMPLE: "simple",
  SCREENING: "screening",
};

export const CHECK_TYPE_CONFIG = [
  { key: CHECK_TYPES.ENHANCED, label: "Enhanced" },
  { key: CHECK_TYPES.STANDARD, label: "Standard" },
  { key: CHECK_TYPES.SIMPLE, label: "Simple" },
  { key: CHECK_TYPES.SCREENING, label: "PEP & Sanctions" },
];

const normalise = (value) =>
  String(value || "")
    .trim()
    .toLowerCase();

export const useAllowedCheckTypes = () => {
  const { userEmail } = useUserEmail();

  const [allowedCheckTypes, setAllowedCheckTypes] = useState([]);
  const [loadingAllowedCheckTypes, setLoadingAllowedCheckTypes] =
    useState(true);

  useEffect(() => {
    if (!userEmail) {
      setAllowedCheckTypes([]);
      setLoadingAllowedCheckTypes(false);
      return;
    }

    const normalisedEmail = normalise(userEmail);
    const userRef = doc(firestore, "AML Checks", normalisedEmail);

    setLoadingAllowedCheckTypes(true);

    const unsubscribe = onSnapshot(
      userRef,
      (snap) => {
        if (!snap.exists()) {
          setAllowedCheckTypes([]);
          setLoadingAllowedCheckTypes(false);
          return;
        }

        const data = snap.data() || {};

        const types = Array.isArray(data.allowedCheckTypes)
          ? data.allowedCheckTypes.map(normalise).filter(Boolean)
          : [];

        setAllowedCheckTypes(types);
        setLoadingAllowedCheckTypes(false);
      },
      (error) => {
        console.error("Failed to listen to allowed check types:", error);
        setAllowedCheckTypes([]);
        setLoadingAllowedCheckTypes(false);
      },
    );

    return () => unsubscribe(); // 🔥 cleanup
  }, [userEmail]);

  const allowedChecks = useMemo(() => {
    return CHECK_TYPE_CONFIG.filter((check) =>
      allowedCheckTypes.includes(check.key),
    );
  }, [allowedCheckTypes]);

  return {
    allowedCheckTypes,
    allowedChecks,
    loadingAllowedCheckTypes,
  };
};
